<template>
  <div class="px-1">
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :egressProfileId="egress_profile_id"
      :showEgressProfile="true"
      :showMatrix1="true"
      :showMatrix2="true"
      :showMatrix3="true"
      :showStudyPlan="true"
      :showCurricularMesh="true"
    ></NavigationBreadcrumb>
    <div>
      <Matrix4 :egress_profile_id="egress_profile_id"></Matrix4>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  name: "Matrix4View",
  components: {
    Matrix4: () => import("@/components/mesh/Matrix4/Matrix4"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      egress_profile_id: Number(this.$route.params.egress_profile_id),
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames("mesh.career", true, "Programas"),
          to: "/careers",
        },
        {
          text: this.$getVisibleNames("manual.matriz_4", true, "Matriz 4"),
          dropdownOptions: [
            "showEgressProfile",
            "showMatrix1",
            "showMatrix2",
            "showMatrix3",
            "showStudyPlan",
            "showCurricularMesh",
          ],
        },
      ];
    },
  },
  methods: {},
  watch: {},
  mounted() {
    if (
      this.user &&
      this.user.student_card &&
      this.user.group_names.includes("ESTUDIANTES") &&
      this.user.student_card.egress_profile != this.egress_profile_id
    ) {
      this.$router.push({
        name: "Page403",
      });
    }
    if (this.user && this.user.group_names.includes("PROFESORES")) {
      this.$restful
        .Get(`/mesh/fully_visible_professor_egress_profiles/`)
        .then((response) => {
          if (!response.includes(this.egress_profile_id)) {
            this.$router.push({
              name: "Page403",
            });
          }
        });
    }
  },
  beforeDestroy() {
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
  },
  created() {
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id)
      .then((response) => {
        this.$store.commit(
          names.MUTATE_TITLE_OF_THE_PRINT,
          `${this.$getVisibleNames("manual.matriz_4", true, "Matriz 4")} - ${
            response.name
          }`
        );
      });
    this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_MATTERS, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_FORMATION_LINES);
    this.$store.dispatch(names.FETCH_COMPETENCES, this.egress_profile_id);
    this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_CAPACITIES);
  },
};
</script>

<style scoped>
</style>